var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "recruit 1a") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "recruit-1a",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#239FB5",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3387,15.6338 C8.8487,15.5978 8.3587,15.5308 7.8727,15.4018 C7.0787,15.1878 6.3567,14.8278 5.6837,14.3958 L1.9747,18.6068 C1.7517,18.8598 1.4407,18.9888 1.1267,18.9888 C0.8617,18.9888 0.5967,18.8968 0.3827,18.7078 C-0.0853,18.2948 -0.1303,17.5828 0.2807,17.1148 L3.9647,12.9358 C3.6517,12.5698 3.3627,12.1778 3.1167,11.7508 C2.0707,9.9398 1.7927,7.8288 2.3347,5.8078 C2.8757,3.7868 4.1727,2.0978 5.9847,1.0518 C7.7967,0.0068 9.9087,-0.2702 11.9277,0.2688 C13.9487,0.8108 15.6387,2.1068 16.6837,3.9178 C17.0987,4.6378 17.3877,5.4048 17.5577,6.1938 C16.8947,5.8168 16.1507,5.5778 15.3557,5.5048 C14.6617,3.8818 13.2737,2.5758 11.4417,2.0848 C10.9277,1.9468 10.4097,1.8808 9.9017,1.8808 C7.2737,1.8808 4.8617,3.6378 4.1517,6.2948 C3.3007,9.4648 5.1897,12.7358 8.3597,13.5848 C8.9427,13.7408 9.5237,13.7758 10.0967,13.7548 C10.2417,14.0018 10.4017,14.2418 10.5867,14.4668 C10.1217,14.8118 9.7057,15.2038 9.3387,15.6338 Z M18.2987,14.7979 C20.3957,15.9599 21.6977,18.1689 21.6977,20.5649 C21.6977,21.9519 18.8657,22.9999 15.1107,22.9999 C11.3547,22.9999 8.5227,21.9519 8.5227,20.5649 C8.5227,18.2819 9.6777,16.1939 11.6147,14.9789 L12.1537,14.6399 L11.6977,14.1949 C10.8207,13.3389 10.3387,12.1939 10.3387,10.9679 C10.3387,8.4809 12.3627,6.4559 14.8517,6.4559 C17.3397,6.4559 19.3617,8.4809 19.3617,10.9679 C19.3617,12.1019 18.9407,13.1859 18.1727,14.0209 L17.7417,14.4889 L18.2987,14.7979 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruit);
export default __webpack_public_path__ + "static/media/recruit.7ed55a1e6fab812d42df06f8e815655e.svg";
export { ForwardRef as ReactComponent };